import { c as _c } from "react/compiler-runtime";
import { Loader } from '@systemeio/ui';
import { useCourse } from 'modules/courses/courses/hooks/use-course';
import { LightCourseSettings } from 'modules/courses/courses/light-course/components/light-course-settings';
import { CourseEditorTypeEnum, CourseId } from 'modules/courses/courses/types/course-interface';
import { DigitalProductChangeInterface, DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface';
import ItemSteps from 'modules/stores/store/components/item-steps';
import { FC, useEffect } from 'react';
import { Link } from 'shared/components/link';
import { SectionMessage } from 'shared/components/section-message';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useCoursePreview } from '../hooks/use-course-preview';
import { useCourseCurriculum } from 'modules/courses/courses/curriculum/hooks/use-cource-curriculum';
interface Props {
  courseId?: CourseId;
  confirmationEmail: DigitalProductChangeInterface['confirmationEmail'];
  onChange: (data: DigitalProductChangeInterface['confirmationEmail']) => void;
  errors: DigitalProductErrorInterface['confirmationEmail'];
}
const Options: FC<Props> = t0 => {
  const $ = _c(40);
  const {
    courseId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    courseData
  } = useCourse(courseId);
  const {
    data: courseCurriculumData
  } = useCourseCurriculum(courseId);
  const {
    showCoursePreview
  } = useCoursePreview();
  let t1;
  let t2;
  if ($[0] !== courseCurriculumData || $[1] !== courseData || $[2] !== courseId || $[3] !== showCoursePreview) {
    t1 = () => {
      if (courseId) {
        showCoursePreview(courseData, courseCurriculumData);
      }
    };
    t2 = [courseId, courseData, courseCurriculumData, showCoursePreview];
    $[0] = courseCurriculumData;
    $[1] = courseData;
    $[2] = courseId;
    $[3] = showCoursePreview;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== t) {
    t3 = t("dashboard.light_course.course_settings");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Loader small={true} />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = {
      key: "loader",
      title: t3,
      element: t4
    };
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const loaderItem = t5;
  let t6;
  if ($[11] !== t) {
    t6 = t("dashboard.light_course.course_settings");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("dashboard.light_course.select_course_to_proceed_with_settings");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <SectionMessage style="warn">{t7}</SectionMessage>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = {
      key: "empty",
      title: t6,
      element: t8
    };
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const emptyStateItem = t9;
  let t10;
  if ($[20] !== t) {
    t10 = t("dashboard.light_course.course_settings");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = `/courses/${courseId}`;
  let t12;
  if ($[22] !== t) {
    t12 = t("dashboard.course.go_to_change_settings");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <Link rel="noreferrer" target="_blank" href={t11} showOpenInNewIcon={true}>{t12}</Link>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t10 || $[28] !== t13) {
    t14 = {
      key: "loader",
      title: t10,
      element: t13
    };
    $[27] = t10;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const advancedCourseSettingsItem = t14;
  if (!courseId) {
    let t15;
    if ($[30] !== emptyStateItem) {
      t15 = <ItemSteps steps={[emptyStateItem]} />;
      $[30] = emptyStateItem;
      $[31] = t15;
    } else {
      t15 = $[31];
    }
    return t15;
  }
  if (!courseData) {
    let t15;
    if ($[32] !== loaderItem) {
      t15 = <ItemSteps steps={[loaderItem]} />;
      $[32] = loaderItem;
      $[33] = t15;
    } else {
      t15 = $[33];
    }
    return t15;
  }
  if (courseData.courseType === CourseEditorTypeEnum.ClassicCourse) {
    let t15;
    if ($[34] !== advancedCourseSettingsItem) {
      t15 = <ItemSteps steps={[advancedCourseSettingsItem]} />;
      $[34] = advancedCourseSettingsItem;
      $[35] = t15;
    } else {
      t15 = $[35];
    }
    return t15;
  }
  if (courseData.courseType === CourseEditorTypeEnum.LightCourse) {
    let t15;
    if ($[36] !== courseId) {
      t15 = <LightCourseSettings courseId={courseId} />;
      $[36] = courseId;
      $[37] = t15;
    } else {
      t15 = $[37];
    }
    return t15;
  }
  let t15;
  if ($[38] !== loaderItem) {
    t15 = <ItemSteps steps={[loaderItem]} />;
    $[38] = loaderItem;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
};
export default Options;